export const paths = [{ "tag": "path", "att": { "d": "M14 10h-4v4h4v-4zm-6 3H2v-2h6v2zm14 0h-6v-2h6v2z" } }];
export const iconName = 'wall-divider';
export const wallDivider = { iconName, paths };
export default paths;
